module.exports = __webpack_public_path__ + "img/checkbox-disabled-unchecked.673a72c8.svg";